import {Dispatch} from 'react'
import {FACTURACION_TYPES} from '../../constants/facturacion.types'
import {
  CalculoArrayProductos,
  FacturacionAction,
  ProductosF,
} from '../../interfaces/facturacion.interface'
import * as validaciones from '../../utils/strings.utils'
import {State} from '../../reducers'
import * as validators from '../../utils/validaciones'
import {generalOpenModalError, generalOpenModalInfo} from '../general.actions'
import {roundToTwo} from '../../utils/numbers.utils'
import { processDetalleImpuestosHTML, procesOtrosImpuestosResumen, processOtrosImpuestosCalculo,getDigitosCalculables, isEmpresa3Digitos } from '../utils-documentos.actions'
import { facturacionFormClienteHandleChange } from './facturacionCliente.actions'

// ******************************************************************************************
export const facturacionFormProductoHandleChange = (formProducto: ProductosF) => ({
  type: FACTURACION_TYPES.FORMPRODUCTOS_HANDLE_CHANGE,
  payload: formProducto,
})

export const facturacionFormProductoAddError = (formError: ProductosF) => ({
  type: FACTURACION_TYPES.FORMPRODUCTOS_SET_ERRORS,
  payload: formError,
})

export const facturacionFormProductoClear = () => ({
  type: FACTURACION_TYPES.FORMPRODUCTOS_CLEAR,
  payload: null,
})

export const facturacionArrayProductoAgregar = (producto: ProductosF) => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_ADD,
  payload: producto,
})

export const facturacionArrayProductosSet = (productos: Array<ProductosF>) => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_SET_DATA,
  payload: productos,
})

export const facturacionArrayProductoDeleteOne = () => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_DELETE_ONE,
  payload: null,
})

export const facturacionArrayProductoClearAll = () => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_CLEAR_ALL,
  payload: null,
})

export const facturacionSetTotalDocRelacionado = (total: string) => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_SET_TOTAL_DOC_RELACIONADO,
  payload: total,
})

export const facturacionArrayProductoSetCalculos = (calculos: CalculoArrayProductos) => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_SET_CALCULOS,
  payload: calculos,
})

export const facturacionArrayProductoSelectOne = (i: number) => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_SELECT_ONE,
  payload: i,
})

export const facturacionArrayProductoEditar = () => ({
  type: FACTURACION_TYPES.ARRAYPRODUCTOS_EDIT,
  payload: null,
})

export const facturacionFormProductoHandleChangeEdit = (formProducto: ProductosF) => ({
  type: FACTURACION_TYPES.FORMPRODUCTOS_HANDLE_CHANGE_EDIT,
  payload: formProducto,
})

export const facturacionFormProductoAddErrorEdit = (formError: ProductosF) => ({ type: FACTURACION_TYPES.FORMPRODUCTOS_SET_ERRORS_EDIT, payload: formError})

export const facturacionDeleteServicios = () => ({ type: FACTURACION_TYPES.FACT_DELETE_SERVICIOS, payload: null})

// ******************************************************************************************
// * ACCIONES DE MODALES
export const facturacionModalsOpenEliminar = () => ({
  type: FACTURACION_TYPES.MODALELIMINAR_OPEN,
  payload: {activeEliminarUno: true},
})

export const facturacionModalsOpenQuitarTodo = () => ({
  type: FACTURACION_TYPES.MODALELIMINAR_OPEN,
  payload: {activeQuitarTodo: true},
})

export const facturacionModalsClose = () => ({
  type: FACTURACION_TYPES.MODALELIMINAR_CLOSE,
  payload: null,
})

export const facturacionOpenModalEditar = (i: number, producto: ProductosF) => ({
  type: FACTURACION_TYPES.MODALEDITAR_OPEN,
  payload: {productoSeleccionado: i, formProductosEdit: producto},
})

export const facturacionCloseModalEditar = () => ({
  type: FACTURACION_TYPES.MODALEDITAR_CLOSE,
  payload: null,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const facturacionFormProductoHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const edit = getState().facturacion.modals.activeEditar
    let {name, value} = e.target
    if (value) {
      switch (name) {
        case 'descripcion':
          if (!validaciones.validarRegexLetras(value)) return
          break
        case 'cantidad':
          if (!validaciones.validaRegexNumericoFloatNDecimales(value)) return
          break
        case 'precio':
        case 'precioConIva':
          if (!validaciones.validaRegexNumericoFloatNDecimales(value)) return
          break
        case 'tipoDescuento':
          break
        case 'descuento':
          if (!validaciones.validaRegexNumericoFloatNDecimales(value)) return
          break
        default:
          break
      }
    }
    if (edit) dispatch(facturacionFormProductoHandleChangeEdit({[name]: value}))
    else dispatch(facturacionFormProductoHandleChange({[name]: value}))
  }

export const facturacionFormProductoUpdateCalculo =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const {productos: productosCatalogo} = getState().catalogos;
    const edit = getState().facturacion.modals.activeEditar
    const idDoc = getState().documentos.activeDoc?.idDoc
    let formProducto = edit
      ? getState().facturacion.formProductosEdit
      : getState().facturacion.formProductos;
    
    let checkExentoImpuesto = getState().facturacion.formCliente.checkExentoImpuesto;
    let {cantidad, precio, descuento, tipoDescuento} = formProducto;
  
    let detalleTributos = "";
    let subtotal_ = 0,
      descuento_ = 0,
      total_ = 0,
      ventasGravadas_ = 0,
      impuesto1 = 0,
      totalImpuesto1 = 0,
      impuesto2 = 0,
      totalImpuesto2 = 0,
      totalConImpuesto1 = 0,
      totalConImpuesto1Desc = 0,
      otrosImpuestos = 0;

    if (idDoc === '01') {
      // * FACTURACIÓN CF
      if (cantidad && precio) {
        // * Calculo del Subtotal
        if(checkExentoImpuesto) {
          precio = (parseFloat(precio) / 1.13).toFixed(2)
        }
        subtotal_ = Number(cantidad) * Number(precio)
      }

      if (cantidad && precio && descuento && tipoDescuento) {
        // * Calculo del descuento
        if (tipoDescuento === 'porcentaje') descuento_ = subtotal_ * (Number(descuento) / 100)
        else descuento_ = Number(descuento)
    
        if (checkExentoImpuesto) {
          total_ = subtotal_ - descuento_;
        } else {
          // * Calculo del total
          total_ = subtotal_ - descuento_;
          // * Calculo del IVA
          impuesto1 = 13
          totalImpuesto1 = total_ - total_ / 1.13
        }

        otrosImpuestos += processOtrosImpuestosCalculo(productosCatalogo, idDoc, formProducto, (subtotal_ / 1.13));
        detalleTributos = processDetalleImpuestosHTML(productosCatalogo, idDoc, formProducto, (subtotal_ / 1.13));

        total_ += otrosImpuestos;
      }
    } else {
      if (cantidad && precio) {
        subtotal_ = Number(cantidad) * Number(precio)
        subtotal_ = Number(roundToTwo(subtotal_))
      }

      if (cantidad && precio && descuento && tipoDescuento) {
        if (tipoDescuento === 'porcentaje') descuento_ = subtotal_ * (Number(descuento) / 100)
        else descuento_ = Number(descuento)

        descuento_ = Number(roundToTwo(descuento_))
        impuesto1 = 13
        total_ = subtotal_ - descuento_
        total_ = Number(roundToTwo(total_))

        totalImpuesto1 = (total_ * impuesto1) / 100
        totalImpuesto1 = Number(roundToTwo(totalImpuesto1))

        impuesto2 = total_ >= 100 ? 1 : 0
        impuesto2 = Number(roundToTwo(impuesto2))
        totalImpuesto2 = (total_ * impuesto2) / 100

        totalConImpuesto1 = subtotal_ + totalImpuesto1
        totalConImpuesto1 = Number(roundToTwo(totalConImpuesto1))
        totalConImpuesto1Desc = totalConImpuesto1 - descuento_
      }
    }

    const body = {
      cantidadDescuento: roundToTwo(descuento_),
      subtotal: roundToTwo(subtotal_),
      total: roundToTwo(total_),
      impuesto1: String(impuesto1),
      totalImpuesto1: roundToTwo(totalImpuesto1),
      impuesto2: String(impuesto2),
      totalImpuesto2: roundToTwo(totalImpuesto2),
      totalConImpuesto1: roundToTwo(totalConImpuesto1),
      totalConImpuesto1Desc: roundToTwo(totalConImpuesto1Desc),
      ventasGravadas: roundToTwo(ventasGravadas_),
      otrosImpuestos: roundToTwo(otrosImpuestos),
      detalleTributos: detalleTributos,
    }
    if (edit) dispatch(facturacionFormProductoHandleChangeEdit(body))
    else dispatch(facturacionFormProductoHandleChange(body))
}

export const facturacionUpdateCalculosExentos = 
  () => async (dispatch: Dispatch<any>, getState: () => State) => {
    let arrayProductos = getState().facturacion.arrayProductos;
    let checkExentoImpuesto = getState().facturacion.formCliente.checkExentoImpuesto;

    // Recalcular subtotales y totales si coloca el cambia el check de exentos
    if (arrayProductos?.length > 0) {
      dispatch(facturacionArrayProductosSet(arrayProductos.map((prod: ProductosF) => {
        let subtotal_ = parseFloat(prod.subtotal!);
        let descuento_ = parseFloat(prod.cantidadDescuento!);
        let total_ = parseFloat(prod.total!);
        let impuesto1 = parseInt(prod.impuesto1!);
        let totalImpuesto1 = parseFloat(prod.totalConImpuesto1!);
      
        if (checkExentoImpuesto) {
          // Remover IVA en el total
          subtotal_ = subtotal_ / 1.13;
          total_ = subtotal_ - descuento_;
        } else {        
          // * Calculo del total
          subtotal_ = parseFloat(prod.cantidad!) * parseFloat(prod.precio!);
          total_ = subtotal_ - descuento_;
          // * Calculo del IVA
          impuesto1 = 13
          totalImpuesto1 = total_ - total_ / 1.13
        }

        return {
          ...prod,
          subtotal: roundToTwo(subtotal_),
          total: roundToTwo(total_),
          impuesto1: roundToTwo(impuesto1),
          totalImpuesto1: roundToTwo(totalImpuesto1),
        }
      })))
    }
}

export const facturacionFormProductoAddProducto =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const edit = getState().facturacion.modals.activeEditar
    let formProductos = edit
      ? getState().facturacion.formProductosEdit
      : getState().facturacion.formProductos
    let errorsFormProductos = edit
      ? getState().facturacion.errorsFormProductosEdit
      : getState().facturacion.errorsFormProductos

    // Validaciones
    errorsFormProductos.descripcion = validators.validacionEsRequerido(
      formProductos.descripcion!,
      errorsFormProductos.descripcion!,
      'Descripción',
      'requerida'
    )

    errorsFormProductos.cantidad = validators.validacionEsRequerido(
      formProductos.cantidad!,
      errorsFormProductos.cantidad!
    )
    if (!errorsFormProductos.cantidad)
      errorsFormProductos.cantidad = validators.validacionNumMinimo(formProductos.cantidad!, 0)
    if (!errorsFormProductos.cantidad)
      errorsFormProductos.cantidad = validators.validacionNumMaximo(
        formProductos.cantidad!,
        100000000000
      )

    errorsFormProductos.precio = validators.validacionEsRequerido(
      formProductos.precio!,
      errorsFormProductos.precio!
    )
    if (!errorsFormProductos.precio)
      errorsFormProductos.precio = validators.validacionNumMinimo(formProductos.precio!, 0)
    if (!errorsFormProductos.precio)
      errorsFormProductos.precio = validators.validacionNumMaximo(
        formProductos.precio!,
        100000000000
      )

    errorsFormProductos.tipoDescuento = validators.validacionEsRequerido(
      formProductos.tipoDescuento!,
      errorsFormProductos.tipoDescuento!
    )

    errorsFormProductos.descuento = validators.validacionEsRequerido(
      formProductos.descuento!,
      errorsFormProductos.descuento!
    )
    if (!errorsFormProductos.descuento)
      errorsFormProductos.descuento = validators.validacionNumMaximo(
        formProductos.descuento!,
        100000000000
      )

    // Validación de Descuento
    if (!errorsFormProductos.descuento) {
      const {tipoDescuento, precio, cantidad} = formProductos
      const {messageError, ms} = validacionDescuento(
        formProductos.descuento!,
        tipoDescuento!,
        precio!,
        cantidad!
      )
      if (messageError) {
        dispatch(generalOpenModalError(messageError))
        errorsFormProductos.descuento = ms
      }
    }
    // Fin de Validaciones

    if (edit) {
      dispatch(facturacionFormProductoAddErrorEdit(errorsFormProductos))
    } else {
      dispatch(facturacionFormProductoAddError(errorsFormProductos))
    }

    if (
      errorsFormProductos.descripcion ||
      errorsFormProductos.cantidad ||
      errorsFormProductos.precio ||
      errorsFormProductos.tipoDescuento ||
      errorsFormProductos.descuento
    )
      return

    if (edit) {
      dispatch(facturacionArrayProductoEditar())
      dispatch(generalOpenModalInfo('El producto fue editado satisfactoriamente.'))
    } else {
      await dispatch(facturacionArrayProductoAgregar({...getState().facturacion.formProductos}))
      await dispatch(facturacionFormProductoClear())
      dispatch(generalOpenModalInfo('El producto agregado satisfactoriamente.'))
    }
  }

export const facturacionCalculoTotalArrayProducto =
  () => async (dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
    const arrayProductos = getState().facturacion.arrayProductos
    const userLogin = getState().userLogin
    const {productos: productosCatalogo} = getState().catalogos
    const idDoc = getState().documentos.activeDoc?.idDoc

    let subtotal = 0, descuento = 0, total = 0, cantidad = 0, impuesto1 = 0,
      impuesto2 = 0, totalConImpuesto1 = 0, subTotalConImpuesto1 = 0, totalIvaPercibido=0, totalConRetecion = 0,
      totalRetencionRenta = 0, totalMontoOperacion = 0, totalPagar = 0, otrosImpuestos = 0
    let resumenTributos:Array<any> = [];

    if (idDoc === '01') {
      const {checkContribuyente, checkExentoImpuesto, checkRetencion1, checkRetencionRenta, checkPropina} = getState().facturacion.formCliente
      if (arrayProductos.length > 0) {
        // Subtotal = sumatoria de precio * cantidad
        subtotal = arrayProductos.reduce((a, b) => Number(a) + Number(b.subtotal), 0)
        // descuento = sumatoria de descuento
        descuento = arrayProductos.reduce((a, b) => Number(a) + Number(b.cantidadDescuento), 0)
        // cantidad = sumatoria de cantidades
        cantidad = arrayProductos.reduce((a, b) => Number(a) + Number(b.cantidad), 0)

        // Si no es exento de impuesto !== Escenario 7
        if(checkExentoImpuesto !== true) {
          // impuesto 1 = sumatorias de impuestos de IVA
          impuesto1 = arrayProductos.reduce((a, b) => Number(a) + Number(b.totalImpuesto1), 0)

          // tipoEmpresa: 1 juridica, 2 Natural
          // tipoContribuyente: 1 grande, 2 mediano, 3 otros
          let tipoEmpresa = getState().catalogos.datosEmisor?.tipoEmpresa;
          let tipoContribuyente = getState().catalogos.datosEmisor?.tipoContribuyente;
          let isFacturaCF = getState().facturacion.formCliente.checkCF

          if(checkRetencionRenta && !isFacturaCF) { 
            // totalRetencionRenta = sumatoria de todos los totales de servicios
            totalRetencionRenta = arrayProductos.reduce((a, b) =>  Number(a) + ((b.tipo === "s") ? Number(b.total) : 0), 0)
            // totalRetencionRenta
            totalRetencionRenta = (totalRetencionRenta/1.13)*0.1            
          }
          if (checkRetencion1) { 
            // Calculo de Retención 1%
            total = arrayProductos.reduce((a, b) =>  Number(a) + Number(b.total), 0)
            impuesto2 = total >= 100  ? total / 1.13 * 0.01 : 0
            impuesto2 = Number(roundToTwo(impuesto2))
          }
        }

        // Otros impuestos
        arrayProductos.forEach((producto) => {
          otrosImpuestos += processOtrosImpuestosCalculo(productosCatalogo, idDoc, producto, (Number(producto.subtotal) / 1.13), false);
          resumenTributos = procesOtrosImpuestosResumen(productosCatalogo, idDoc, resumenTributos, producto, (Number(producto.subtotal) / 1.13));
        })
    
        resumenTributos.forEach((resum) => {
          resum.valor = parseFloat(resum.valor.toFixed(2));
        });

        total = subtotal - descuento + otrosImpuestos
        // totalMontoOperacion = total
        totalMontoOperacion = total;
        // totalPagar = Monto de Operación - Retencion Renta
        totalPagar = totalMontoOperacion + totalIvaPercibido - totalRetencionRenta - impuesto2
        if(checkPropina) { 
          totalPagar = userLogin?.propina?.propina_activa ? totalPagar + (totalPagar * userLogin?.propina?.cantidad_propina) : totalPagar 
        }  
      }
    } else {
      if (arrayProductos.length > 0) {
        subtotal = arrayProductos.reduce((a, b) => Number(a) + Number(b.subtotal), 0)
        descuento = arrayProductos.reduce((a, b) => Number(a) + Number(b.cantidadDescuento), 0)
        total = arrayProductos.reduce((a, b) => Number(a) + Number(b.total), 0)
        cantidad = arrayProductos.reduce((a, b) => Number(a) + Number(b.cantidad), 0)
        impuesto1 = arrayProductos.reduce((a, b) => Number(a) + Number(b.totalImpuesto1), 0)

        impuesto2 = total * (total >= 100 ? 0.01 : 0)
        impuesto2 = Number(roundToTwo(impuesto2))

        subTotalConImpuesto1 = subtotal + impuesto1

        totalConImpuesto1 = subtotal + impuesto1 - descuento
        totalConImpuesto1 = Number(roundToTwo(totalConImpuesto1))

        totalConRetecion = totalConImpuesto1 - impuesto2
      }
    }

    if (totalPagar >= 25000) {
      // Si es mayor a la cantidad, remover el CF para hacer obligatorio el tipo de documento
      dispatch(facturacionFormClienteHandleChange({checkCF: false, validacionMonto25000: true}));
    } else {
      dispatch(facturacionFormClienteHandleChange({validacionMonto25000: false}));
    }

    dispatch(
      facturacionArrayProductoSetCalculos({
        subtotal: roundToTwo(subtotal),
        descuento: roundToTwo(descuento),
        total: roundToTwo(total),
        totalCantidad: String(cantidad),
        totalImpuesto1: roundToTwo(impuesto1),
        totalImpuesto2: roundToTwo(impuesto2),
        subTotalConImpuesto1: roundToTwo(subTotalConImpuesto1),
        totalConImpuesto1: roundToTwo(totalConImpuesto1),
        totalConRetecion: roundToTwo(totalConRetecion),
        totalIvaPercibido: roundToTwo(totalIvaPercibido),
        totalRetencionRenta: roundToTwo(totalRetencionRenta),
        totalMontoOperacion: roundToTwo(totalMontoOperacion),
        totalPagar: roundToTwo(totalPagar),
        otrosImpuestos: roundToTwo(otrosImpuestos),
        resumenTributos: resumenTributos,
      })
    )
  }

  
export const facturacionProductosVerificacionServicios = () => async(dispatch: Dispatch<FacturacionAction>, getState: () => State) => {
  const productos = getState().facturacion.arrayProductos;
  const servicios = productos.filter((el) => el.tipo === "s");
  return servicios.length > 0;
}

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const facturacionFormProductoValidacionesOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<any>, getState: () => State) => {
    const edit = getState().facturacion.modals.activeEditar
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'descripcion':
        message = validators.validacionEsRequerido(value, message, 'Descripción', 'requerida')
        break
      case 'cantidad':
        message = validators.validacionEsRequerido(value, message)
        if (!message) message = validators.validacionNumMinimo(value, 0)
        if (!message) message = validators.validacionNumMaximo(value, 100000000000)
        break
      case 'precio':
      case 'precioConIva':
        if (name === 'precioConIva') name = 'precio'
        message = validators.validacionEsRequerido(value, message)
        if (!message) message = validators.validacionNumMinimo(value, 0)
        if (!message) message = validators.validacionNumMaximo(value, 100000000000)
        break
      case 'tipoDescuento':
        message = validators.validacionEsRequerido(value, message)
        break
      case 'descuento':
        message = validators.validacionEsRequerido(value, message)
        if (!message) message = validators.validacionNumMaximo(value, 100000000000)

        // Validación de Descuento
        if (!message) {
          const {tipoDescuento, precio, cantidad} = edit
            ? getState().facturacion.formProductosEdit
            : getState().facturacion.formProductos
          const {messageError, ms} = validacionDescuento(value, tipoDescuento!, precio!, cantidad!)
          if (messageError && !edit) dispatch(generalOpenModalError(messageError))
          message = ms
        }

        break
      default:
        break
    }

    if (edit) dispatch(facturacionFormProductoAddErrorEdit({[name]: message}))
    else dispatch(facturacionFormProductoAddError({[name]: message}))
  }

const validacionDescuento = (
  value: string,
  tipoDescuento: string,
  precio: string,
  cantidad: string
) => {
  let messageError = '',
    ms = ''
  let num = parseFloat(value)
  if (tipoDescuento === 'porcentaje') {
    if (num > 100) {
      messageError = 'El Descuento no puede ser mayor a 100%'
      ms = 'Desc. incorrecto'
    }
  } else {
    if (precio && cantidad) {
      let subtotal = Number(precio) * Number(cantidad)
      if (num > subtotal) {
        messageError = 'El Descuento no debe ser mayor al subtotal'
        ms = 'Desc. incorrecto'
      }
    }
  }
  return {messageError, ms}
}
